// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

import IGalleryItem from "./IGalleryItem";

export default interface IGallery {
  items: IGalleryItem[];
}
